var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.alert)?_c('v-alert',{attrs:{"color":_vm.background,"dense":"","text":"","type":_vm.typestatus}},[_vm._v(_vm._s(_vm.textInfo))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }